(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed')) {
    class RecentlyViewed extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.observer?.disconnect();
        const key = 'takbutikk-recent-products-v1';
        const current = this.validPath(this.dataset.productUrl);
        if (!current) return;
        let history = [];
        try {
          const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
          if (Array.isArray(saved)) history = [...new Set(saved.map(item => this.validPath(item)).filter(Boolean))];
        } catch {}
        try {
          sessionStorage.setItem(key, JSON.stringify([current, ...history.filter(path => path !== current)].slice(0, 12)));
        } catch {}
        const paths = history.filter(path => path !== current).slice(0, Number(this.dataset.limit) || 4);
        if (!paths.length) return;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load(paths, this.controller.signal);
          }, { rootMargin: '400px' });
          this.observer.observe(this);
        } else {
          this.load(paths, this.controller.signal);
        }
      }
      validPath(value) {
        if (typeof value !== 'string' || value.length > 500) return null;
        try {
          const url = new URL(value, location.origin);
          const root = this.dataset.productsRoot;
          if (url.origin !== location.origin || !url.pathname.startsWith(root)) return null;
          const handle = decodeURIComponent(url.pathname.slice(root.length));
          if (!handle || /[\s/\\?#]/u.test(handle)) return null;
          return url.pathname;
        } catch { return null; }
      }
      async load(paths, signal) {
        const cards = await Promise.all(paths.map(async path => {
          try {
            const url = new URL(path, location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
            const response = await fetch(url, { signal, credentials: 'same-origin' });
            if (!response.ok) return null;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const template = html.querySelector('template[data-recent-card]');
            if (!template || this.validPath(template.dataset.productUrl) !== path) return null;
            return template.content.cloneNode(true);
          } catch { return null; }
        }));
        if (signal.aborted || !this.isConnected) return;
        const list = this.querySelector('[data-recent-list]');
        list.replaceChildren(...cards.filter(Boolean));
        this.querySelector('[data-recent-content]').hidden = !list.children.length;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    }
    customElements.define('recently-viewed', RecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();
})();
